import React, { useEffect } from "react";
import "../../assets/scss/themes.scss";
//Import Components
import UserChat from "./Chats/UserChat";
import Chats from "./Chats/Chats";
import { configureStore } from "../../store/messenger/store";
import { Provider } from "react-redux";
import Layout from "./Chats/Layout";
import { useSelector } from "react-redux";
import {
  updateActiveUser,
  updateMessages,
  deleteMessage,
  updateContacts,
  updateConversations,
  deleteContacts,
  updateMoreMessages,
  updateForwardMessage,
  updateSingleMessage,
  updateSingleMessageReactions,
} from "../../store/messengerSlice";
import { updateGroupMessages, updateMessages as updateIndividualMsg } from "../../services/conversations";
import { useDispatch } from "react-redux";
import { useSocket } from "../../store/context/SocketProvider";
import { getMessages, getGroupMessages } from "../../services/conversations";
function ChatBoard() {
  const messenger = useSelector((state) => state.messenger);
  const { fetchUpdatedMessages, socket } = useSocket();
  const dispatch = useDispatch();

  const setActiveUser = (key) => {
    dispatch(updateActiveUser(key));
  };

  const setMessagestoState = (obj) => {
    dispatch(
      updateMessages({
        key: messenger.activeUser,
        message: obj,
      })
    );
  };

  const fetchMessages = () => {
    fetchUpdatedMessages();
  };

  const deleteMessageFromState = (id) => {
    dispatch(
      deleteMessage({
        id,
      })
    );
  };

  const updateSingleMessageInState = (message) => {
    dispatch(
      updateSingleMessage({
        id: message.id,
        message: message.updatedMessage,
      })
    );
  };

  const updateSingleMessageReactionInState = (message) => {
    dispatch(
      updateSingleMessageReactions({
        id: message.id,
        reactions: message.updatedReactions,
      })
    );
  };

  const handleUpdateContacts = (cntcts) => {
    dispatch(updateContacts(
      cntcts
    ))
  }

  const handleUpdateConversations = (data) => {
    dispatch(updateConversations([data]))
  }

  const handleDelConversation = (id) => {
    dispatch(deleteContacts(id))
  }

  const handleForwardMessage = (msg) => {
    dispatch(updateForwardMessage(msg));
  }

  const handleFetchMore = async (convId, isGroup, page) => {
    if (isGroup) {
      const res = await getGroupMessages(convId, page)
      updateMoreMessages(res.data.reverse())
    } else {
      const res = await getMessages(convId, page)
      updateMoreMessages(res.data.reverse())
    }
  }

  const msgSeenUpdate = async () => {
    console.log("updating status.....")
    const currentUser = messenger?.currentUser;
    const activeUser = messenger.activeUser;
    const conversations = messenger?.conversations?.[activeUser];
    if (!conversations) return;

    const currentConversation = conversations[0];
    const isGroupChat = messenger?.contacts?.[activeUser]?.isGroupChat;

    const unseenMessages = currentConversation.filter(
      (msg) =>
        msg.sender !== currentUser?._id &&
        msg.status !== 'seen' &&
        msg.status !== 'deleted'
    );

    if (unseenMessages?.length <= 0) return;

    const unseenMsgsId = unseenMessages.map((msg) => msg._id);

    try {
      // Update all unseen messages
      await Promise.all(
        unseenMessages.map(async (msg) => {
          const updatePayload = {
            ...msg.conversation,
            status: "seen"
          };

          if (isGroupChat) {
            await updateGroupMessages(msg._id, updatePayload);
          } else {
            await updateIndividualMsg(msg._id, updatePayload);
          }
        })
      );
      // Emit the socket event once after updates
      socket?.emit("seenMessage", {
        conversationId: messenger?.conversationsIds?.[activeUser],
        messagesId: unseenMsgsId,
        senderId: unseenMessages?.[unseenMessages.length - 1]?.sender,
        type: isGroupChat ? "group" : "individual"
      });

    } catch (error) {
      console.error("Error updating conversation media:", error);
    }
  };

  console.log("chat board", messenger);
  return (
    <Provider store={configureStore()}>
      <React.Fragment>
        <Layout>
          {/* chat-list  */}
          <Chats
            contacts={messenger.contacts}
            conversations={messenger.conversations}
            active_user={messenger.activeUser}
            setActiveUser={setActiveUser}
            fetchUpdatedMessages={fetchMessages}
            onlineContacts={messenger.onlineUsers}
            msgSeenUpdate={msgSeenUpdate}
          />

          {/* user-chat */}
          <UserChat
            contacts={messenger.contacts}
            currentUser={messenger.currentUser}
            active_user={messenger.activeUser}
            conversations={messenger.conversations}
            setMessagestoState={setMessagestoState}
            deleteMessageFromState={deleteMessageFromState}
            updateContacts={handleUpdateContacts}
            conversationsIds={messenger.conversationsIds}
            handleUpdateConversations={handleUpdateConversations}
            handleDelConversation={handleDelConversation}
            handleFetchMore={handleFetchMore}
            handleForwardMessage={handleForwardMessage}
            msgSeenUpdate={msgSeenUpdate}
            fetchUpdatedMessages={fetchMessages}
            updateSingleMessageInState={updateSingleMessageInState}
            updateSingleMessageReactionInState={updateSingleMessageReactionInState}
          />
        </Layout>
      </React.Fragment>
    </Provider>
  );
}

export default ChatBoard;
